import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 text-center mb-12">
          Häufig gestellte Fragen
        </h2>

        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h4 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h4>
                <span className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full border border-foreground-200 transition-transform duration-200 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-600 text-xs"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Mehr erfahren
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
        </div>
      </div>
    </section>
  );
}